module.exports = __webpack_public_path__ + "static/media/0020.5bba2a54.jpg";